import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AgentActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/RealEstate/Agent/AgentBrowser")
	}

	render() {
		return (
			<Activity 
				name="Agent"
				RenderedComponent={this.RenderedComponent}
				context="Agent"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AgentActivity)
